import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { orderItemAdd } from '../actions/index';

class MenuItems extends Component {

  // Add an item to the current order
  handleOrderAdd = (item_id, cat_id) => {
    var item = {
      id: item_id,
      cat_id: cat_id,
      name: this.props.restaurant.menuItems[cat_id].items[item_id].name,
      price: this.props.restaurant.menuItems[cat_id].items[item_id].price,
      note: '',
      has_modifiers: this.props.restaurant.menuItems[cat_id].items[item_id].has_modifiers,
    };
    this.props.orderItemAdd(item);
  }

  renderMenuItems() {
    let items = [];

    if (Object.keys(this.props.restaurant.activeCategory).length !== 0) {
      items = Object.values(this.props.restaurant.menuItems[this.props.restaurant.activeCategory.id].items);
    }

    return items.map( (item, index) => {
      return(
        <div
          key={item.id}
          className="col-md-2 menuitem-col"
          id={item.id}
          onClick={event => this.handleOrderAdd(event.target.id, this.props.restaurant.activeCategory.id)}>
          <div id={item.id} className="h6 menu-item-span">
            {item.name} <br />{item.price.toFixed(2)}
          </div>
        </div>
      );
    });
  }

  render() {
    return(
      <div className="row no-gutter">
        {this.renderMenuItems()}
      </div>
    );
  }
}

function mapStateToProps({ restaurant }) {
  return { restaurant };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { orderItemAdd }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuItems);



// WEBPACK FOOTER //
// ./src/components/menu_items.js